export var dataHooks = {
  status: 'input-status'
};
export var SIZES = {
  small: 'small',
  medium: 'medium',
  normal: 'normal',
  large: 'large'
};